import { useState, useEffect } from "react";
import { Place } from "../types/place";
import { getPlaceById } from "../services/placeService";

export const useDetailPlace = (
  id: string | null,
  t: (key: string) => string
) => {
  const [place, setPlace] = useState<Place | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;
    let isMounted = true;
    setLoading(true);

    getPlaceById(id, t)
      .then((data) => {
        if (isMounted) setPlace(data);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [id, t]);

  return { place, loading };
};
